import React from 'react';
import {Link} from 'react-router-dom';
import ArticlesOfIncorporationPdf from '../Articles_of_Incorporation_signed.pdf';
import BylawsPdf from '../Bylaws_signed.pdf';

var Footer = props => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 mx-auto">
            <div className="row">
              <div className="col-md-6 center">
                <Link className="nav-link" to="/privacy">Privacy Policy</Link>
              </div>
              <div className="col-md-6 center">
                <Link className="nav-link" to="/refund">Refund Policy</Link>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 center">
                <a className="nav-link" href = {ArticlesOfIncorporationPdf} target = "_blank">Articles of Incorporation</a>
              </div>
              <div className="col-md-6 center">
                <a className="nav-link" href = {BylawsPdf} target = "_blank">Bylaws</a>
              </div>
            </div>
            <p className="copyright">Copyright &copy; Walter M. Cunningham Education Foundation 2018</p>
          </div>
        </div>
      </div>
    </footer>
    )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js